import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { auth } from "../../../firebase/firebase.utils";
import { connect } from "react-redux";
import { setCurrentAdmin } from "../../../actions";
import { User, LogOut } from "react-feather";
//images import
import man from "../../../assets/images/dashboard/user2.jpg";
export class User_menu extends Component {
  render() {
    const { currentAdmin } = this.props;
    return (
      <Fragment>
        <li className="onhover-dropdown kd-user-menu">
          <span className="kd-avatar">
            <img
              src={currentAdmin && currentAdmin.image ? currentAdmin.image : man}
              alt="header-user"
            />
            <span className="kd-avatar-dot" aria-hidden="true" />
          </span>
          <ul className="profile-dropdown onhover-show-div kd-pop-menu">
            <li className="kd-pop-head kd-pop-head--user">
              <strong>{currentAdmin ? currentAdmin.name : "Admin"}</strong>
              {currentAdmin && currentAdmin.status && (
                <span className="sb-user-role">{currentAdmin.status}</span>
              )}
            </li>
            <li>
              <Link to={`${process.env.PUBLIC_URL}/settings/profile`} className="kd-pop-item">
                <User size={16} />
                Profile
              </Link>
            </li>
            <li>
              <button
                type="button"
                className="kd-pop-item kd-pop-item--danger"
                onClick={() => {
                  auth.signOut();
                  this.props.setCurrentAdmin(null);
                  this.props.history.push("/");
                }}
              >
                <LogOut size={16} />
                Log out
              </button>
            </li>
          </ul>
        </li>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
  };
};
export default withRouter(connect(mapStateToProps, { setCurrentAdmin })(User_menu));
